import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const shareCompanyCodeApi = (data, callback, errorCallBack) => {
   
  return async (dispatch) => {
    
    formDataCommonFunction(data,apiConstants.COMPANIES.SHARE_COMPANY_CODE)
      .then((response) => {
        callback && callback(response)
      
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
